// extracted by mini-css-extract-plugin
export default {"wrapper":"PartialPageLoader_wrapper__UeU9B","transparent":"PartialPageLoader_transparent__U7zWE"};